import moment from 'moment';

export function toFullString(string) {
  return moment(string, 'YYYY-MM-DD').format('MMM D, YYYY');
}



// WEBPACK FOOTER //
// ./src/utils/date.js